import { BankingEntitiesPaymentStatusEnum, BankingPaymentFilter } from 'generated/resources/graphql'

import useFilters from 'modules/core/components/DataTable/hooks/useFilters'
import i18n from 'modules/core/lib/i18n'

import { buildPaymentsAmountWidget } from 'modules/banking/components/Widgets/PaymentsAmountWidget'
import { buildPaymentsCountWidget } from 'modules/banking/components/Widgets/PaymentsCountWidget'
import { buildTransfersCountWidget } from 'modules/banking/components/Widgets/TransferCountWidget'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'

const PaymentStatuses: Record<'inProgress' | 'pending', BankingEntitiesPaymentStatusEnum[]> = {
  inProgress: ['in_progress'],
  pending: ['init', 'pending_consent'],
}
interface PaymentInsightsProps {
  defaultCurrency: string
  locale: string
}

export const PaymentInsights = ({ defaultCurrency, locale }: PaymentInsightsProps) => {
  const { getFiltersVariables } = useFilters()

  const amountFormatter = (value: unknown) =>
    formattedAmount({ amountCents: Number(value), currency: defaultCurrency, locale })
  const dataTableFilters: BankingPaymentFilter = getFiltersVariables().filter ?? {}

  const widgets = [
    buildPaymentsAmountWidget({
      widgetTitle: i18n.t('finance.overview.outstanding_payments.total_value'),
      filters: { currency: { in: [defaultCurrency] }, ...dataTableFilters },
      prepareDataArgs: { amountFormatter },
    }),
    buildPaymentsCountWidget({
      widgetTitle: i18n.t('banking.payments.statuses.in_progress'),
      filters: {
        currency: { in: [defaultCurrency] },
        ...dataTableFilters,
        status: { in: PaymentStatuses.inProgress },
      },
    }),
    buildPaymentsCountWidget({
      widgetTitle: i18n.t('banking.payments.statuses.pending'),
      filters: {
        currency: { in: [defaultCurrency] },
        ...dataTableFilters,
        status: { in: PaymentStatuses.pending },
      },
    }),
    buildTransfersCountWidget({
      widgetTitle: i18n.t('banking.payments.payments_not_managed'),
      paymentFilters: { currency: { in: [defaultCurrency] }, ...dataTableFilters },
      queryArgs: {
        onlyPending: true,
        dueThisWeek: false,
        onTime: false,
        overdue: false,
      },
    }),
  ]

  return <DataTableWidgetInsights useBox widgets={widgets} widgetWidth="full" />
}
